import { gridPrefixCls } from "@/base/components/grid/Grid.component";
import {
  genComponentStyleHook,
  type FullToken,
  type GenerateStyle,
} from "antd/es/theme/internal";

const genStyle: GenerateStyle<FullToken<"Grid">> = () => ({
  [`&.${gridPrefixCls}`]: {},
});

export const useGridStyle = genComponentStyleHook(["Grid", "cso"], (token) => {
  return [genStyle(token)];
});
